import { lazy, Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader";

const Signin = lazy(() => import("../screens/Auth/Signin"));
const ForgetPass = lazy(() => import("../screens/Auth/Forget-password"));
const ResetPass = lazy(() => import("../screens/Auth/Reset-password"));

const AuthNavigator = () => {
  const Location = useLocation();
  const token = Location.search.includes("token");

  return (
    <Suspense fallback={<Loader loading={true} />}>
      <Routes>
        <Route path="/signin" element={<Signin />} />
        {/* <Route path="/signup" element={<Signup />} /> */}
        <Route path="/forget-password" element={<ForgetPass />} />
        {token && <Route path={`/reset-password`} element={<ResetPass />} />}
        <Route path="/*" element={<Navigate to="/signin" />} />
      </Routes>
    </Suspense>
  );
};
export default AuthNavigator;
